import { ACCOUNT_ROUTE_NAME } from "@/libs/route-name";
export const addressRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ADDRESS_EDIT,
    path: "account/address/edit/:id",
    component: () => import("@/pages/address-payment/edit-address.vue"),
    meta: {
      requireAuth: true
    }
  };
};

export const newAddressRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.NEW_ADDRESS,
    path: "account/address/new",
    component: () => import("@/pages/address-payment/new-address.vue")
  };
};
